import GetSchedulerByLessonsRequestModelBase from '../_generated/modelBases/get-scheduler-by-lessons-request-model-base';

export default class GetSchedulerByLessonsRequestModel extends GetSchedulerByLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
